import { FC } from 'react';
import styled from 'styled-components';
import premiumDiamond from '../../assets/images/premium-diamond.png';

type UpgradeDiamondProps = {
  size?: number;
  /**
   * The asset is a black diamond. Invert it on the dark tab bar so it stays visible.
   * Leave it off on light pages.
   */
  invert?: boolean;
};

const Diamond = styled.img<{ $invert?: boolean }>`
  display: block;
  filter: ${props => (props.$invert ? 'invert(1)' : 'none')};
`;

/** Upgrade marker shown beside features that need a higher plan. */
const UpgradeDiamond: FC<UpgradeDiamondProps> = ({ size = 14, invert = false }) => (
  <Diamond src={premiumDiamond} alt="" width={size} height={size} $invert={invert} />
);

export default UpgradeDiamond;
